<script>
  import { ref, watch, onMounted, nextTick, h } from 'vue';
  export default {
    props: {
      invalidBrowser: {
        type: Boolean,
        default: false,
      },
      shown: {
        type: Boolean,
        default: false,
      },
      name: {
        type: String,
        default: 'fadein',
      },
      delay: {
        type: Number,
        default: 0,
      },
    },

    setup(props, { slots }) {
      const elementRef = ref(null);

      const getElement = () => {
        return elementRef.value;
      };
      const addInitial = (invalidBrowser) => {
        const el = getElement();
        if (!el || !el.classList) { return; }

        if (invalidBrowser) {
          el.classList.remove(`${props.name}-initial`);
        } else {
          el.classList.add(`${props.name}-initial`);
        }
      };
      const show = () => {
        setTimeout(() => {
          const el = getElement();
          if (!el || !el.classList) { return; }

          el.classList.add(
            `${props.name}-enter`,
            `${props.name}-enter-active`
          );
          el.classList.remove(
            `${props.name}-leave`,
            `${props.name}-leave-active`
          );
        }, props.delay);
      };
      const hide = () => {
        const el = getElement();
        if (!el || !el.classList) { return; }

        el.classList.add(`${props.name}-leave`, `${props.name}-leave-active`);
        el.classList.remove(
          `${props.name}-enter`,
          `${props.name}-enter-active`
        );
      };
      watch(() => props.shown, (value) => {
        if (props.invalidBrowser) { return; }

        if (value) {
          show();
        } else {
          hide();
        }
      });
      watch(() => props.invalidBrowser, (invalidBrowser) => {
        addInitial(invalidBrowser);
      });
      onMounted(() => {
        nextTick(() => {
          addInitial(props.invalidBrowser);
          if (props.shown) {
            show();
          }
        });
      });
      return () => {
        const defaultSlots = slots.default?.();
        if (defaultSlots && defaultSlots.length > 0) {
          const firstSlot = defaultSlots[0];
          if (firstSlot && firstSlot.type !== 'text' && typeof firstSlot.type !== 'symbol') {
            // Use h() to create a proper vnode with ref
            return h(firstSlot.type, {
              ...firstSlot.props,
              ref: elementRef
            }, firstSlot.children);
          }
        }
        return null;
      };
    },
  };
</script>
<style scoped lang="stylus">
.fadein-initial
  opacity 0
.fadein-enter
  opacity 1
.fadein-enter-active
  transition opacity 1s ease
.fadein-leave
  opacity 0.2
.fadein-leave-active
  transition opacity 0.5s ease
.slide-initial
  opacity 0
  position relative
  right -100px
.slide-enter
  opacity 1
  right 0px
.slide-enter-active
  transition opacity 1s ease, right 1s ease
.slide-leave
  opacity 0.2
.slide-leave-active
  transition opacity 0.5s ease
.fadein-less-gray-initial
  opacity: 0.1
.fadein-less-gray-enter-active 
  transition opacity 2s ease-out forwards
.fadein-less-gray-enter
  opacity 1
.fadein-less-gray-leave-active
  transition opacity 300ms ease-out forwards
.fadein-less-gray-leave
  opacity 0.1
/* BUTTON */
.find-button-initial
  opacity 0
  transform: scale(0, 1)
.find-button-initial > *
  position relative
  opacity 0
  top -20px
.find-button-enter 
  opacity 1
  transform scale(1, 1)
.find-button-enter-active
  transition all 500ms ease-out 100ms
.find-button-leave
  opacity 0
.find-button-leave-active
  transition all 200ms linear
.find-button-enter > *
  opacity 1
  top 0px
.find-button-enter-active > *
  transition all 500ms linear 300ms
.fadein-less-gray-initial
  opacity 0.1
.fadein-less-gray-enter
  opacity 1
.fadein-less-gray-enter-active
  transition opacity 2000ms ease-out
.fadein-less-gray-leave
  opacity 0.1
.fadein-less-gray-leave-active
  transition opacity 500ms ease-out
.fadein-steps-initial
  opacity 0.1
.fadein-steps-enter
  opacity 1
.fadein-steps-enter-active
  transition opacity 500ms linear
.fadein-steps-leave
  opacity 0.1
.fadein-steps-leave-active
  transition opacity 500ms linear
</style>
